module.exports = __webpack_public_path__ + "img/BlinkArt_Sword3_Blue.91fea594.png";